// @ts-ignore
import { createAddItem, createDeleteItem } from '../../../actions';
// @ts-ignore
import { createFetchProductDetails } from '../../../actions/product';

export interface AddItemParams {
  parentId: string;
  copiedFrom: string;
  currencyId: string | null | undefined;
  sku: string | null | undefined;
  divisionId: string | null | undefined;
  isSageConnect: boolean;
}

export interface ProductSearchDispatchersOptions {
  dispatch: (action: unknown) => unknown;
  order?: { order_id?: string; order_type?: string } | null;
  catalogId?: string | null;
  isAddingToProjectNote?: boolean;
}

/**
 * Single home for the popup add-item branching shared by product search
 * containers rendered outside ProductSearch (Connected+, PoD, and future
 * migrated tabs). Callers map their own item shape to AddItemParams.
 */
export function makeProductSearchDispatchers({
  dispatch,
  order,
  catalogId,
  isAddingToProjectNote = false,
}: ProductSearchDispatchersOptions) {
  const addItem = (
    params: AddItemParams,
    kwargs: Record<string, unknown> = { fetch_update: true },
  ) => {
    const { parentId, copiedFrom, currencyId, sku, divisionId, isSageConnect } = params;

    if (isAddingToProjectNote) {
      return dispatch(createFetchProductDetails(parentId, copiedFrom, 'MESSAGE'));
    }

    if (catalogId) {
      return dispatch(createAddItem(
        catalogId, 'PRODUCT', parentId, copiedFrom, null, null, null,
        currencyId,
        null, sku, divisionId, 'all', isSageConnect as unknown as string, { ...kwargs },
      ));
    }

    if (!order) {
      console.error('addItemDispatcher: No order provided and not adding to project note');
      return;
    }

    const { order_type, order_id } = order;

    if ('OPPORTUNITY' === order_type || !order_type) {
      return dispatch(createFetchProductDetails(parentId, copiedFrom, 'MESSAGE'));
    }

    if ('PRESENTATION' === order_type || 'COLLECTION' === order_type || 'SHOP' === order_type) {
      return dispatch(createAddItem(
        order_id, 'OPTION', parentId, copiedFrom, null, null, null,
        currencyId,
        null, sku, divisionId, 'reference', isSageConnect as unknown as string, { ...kwargs },
      ));
    }

    return dispatch(createAddItem(
      order_id, 'PRODUCT', parentId, copiedFrom, null, null, null,
      currencyId,
      null, sku, divisionId, 'all', isSageConnect as unknown as string, { ...kwargs },
    ));
  };

  const deleteItem = (itemId: string) => dispatch(createDeleteItem(itemId));

  return { addItem, deleteItem };
}
